<template>
  <div class="payment-method-list-item__wrapper">
    <div
      class="payment-method-list-item"
      v-for="(paymentMethod, key) in this.paymentMethods"
      :key="key"
      @click="handleMethod(paymentMethod)"
    >
      <div class="payment-method-list-item__icon">
        <component :is="paymentMethodsLabels[paymentMethod].icon" />
      </div>
      <div class="payment-method-list-item__label">
        {{ paymentMethodsLabels[paymentMethod].text }}
      </div>
      <div class="payment-method-list-item__next"><ChevronRightIcon /></div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import CCIcon from '@/assets/icons/creditcard_two.svg'
import PaypalIcon from '@/assets/icons/paypal_on_file_small.svg'
import ChevronRightIcon from '@/assets/icons/chevron_right.svg'
import CONSTANTS from '@/constants'

export default {
  name: 'PaymentMethodListItems',
  components: {
    CCIcon: { ...CCIcon, name: 'CCIcon' },
    PaypalIcon: { ...PaypalIcon, name: 'PaypalIcon' },
    ChevronRightIcon: { ...ChevronRightIcon, name: 'ChevronRightIcon' },
  },
  data() {
    return {
      paymentMethods: CONSTANTS.PAYMENT_METHODS,
      paymentMethodsLabels: {
        card: {
          text: 'Credit or debit card',
          icon: CCIcon,
        },
        paypal: {
          text: 'PayPal',
          icon: PaypalIcon,
        },
      },
    }
  },
  methods: {
    ...mapMutations({
      setIsPaymentFormShown: 'app/IS_PAYMENT_MODAL_SHOWN_UPDATED',
      setIsPaymentSelectorModalShown: 'app/IS_PAYMENT_SELECTOR_MODAL_SHOWN_UPDATED',
    }),
    handleMethod(method) {
      this.$store.dispatch('recurly/setRecurlyToken', '')
      this.$store.dispatch('subscriptions/setPaymentMethod', method)
      this.$emit('close-payment-selector-modal')
      if (this.paymentMethod === '') {
        this.setIsPaymentSelectorModalShown(true)
      } else {
        this.setIsPaymentFormShown(true)
      }
    },
  },
}
</script>

<style lang="scss">
.payment-method-list-item {
  &__wrapper {
    color: var(--white);
    width: 100%;
  }
  display: flex;
  align-items: center;
  padding: 10px 15px 10px 10px;
  border-radius: 10px;
  transition: all 1s ease-out;
  margin-bottom: 10px;
  cursor: pointer;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &__icon {
    margin-right: 15px;
    svg {
      display: block;
    }
  }
  &__label {
    font-family: var(--font-regular);
    font-style: normal;
    font-weight: 450;
    width: 100%;
    @include desktop {
      font-size: rem(14);
      line-height: 20px;
    }
  }
}
</style>
